
import { Label as HeadlessLabel } from "@headlessui/react";

import { cn } from "../lib/utils";

function Label( { className, ...props } ) {
  
  return (

    <HeadlessLabel

      className={ cn( "text-black text-sm sm:text-base", className ) }

      { ...props }  

    />

  )

}

export { Label }
